var SliderGalerieArtiste = {
	init:function(){
		var _carousel = $(".slider-galerie-artiste");

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

		//var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

		var _slides_to_show = 1;

		_carousel.slick({
			arrows:false, 
			dots:true,
			infinite: false,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			focusOnSelect: true,
			touchThreshold:500
		});	
	}
}

$(window).load(function(){
	if($('.slider-galerie-artiste').length){
		SliderGalerieArtiste.init();
	}
});